export default __webpack_public_path__ + "static/perflow-cf573e238ec7bc36ad807b0835110c1c.gif";